import { selectCategory } from "@/store/slices/category";
import styles from "./banner.module.scss";
import Image from "next/image";
import bannerBottom from "@/assets/images/banner_bottom.png";
import love from "@/assets/images/love23.png";
import offer from "@/assets/images/offer.png";
import React from "react";
import { useSelector } from "react-redux";
const CatgeoryBanner = () => {
  const categoryState = useSelector(selectCategory);

  return (
    <>
      {!!categoryState.data?.banner_image && (
        <section className={styles.banner}>
          <Image
            src={categoryState.data.banner_image}
            alt={categoryState.data.title}
            layout="fill"
            objectFit="cover"
            unoptimized
            priority
          />
        </section>
      )}
      {false && (
        <section className={styles.banner_bottom_main}>
          <div className="container">
            <div className={styles.banner_bottom_container}>
              <Image
                src={bannerBottom}
                alt=""
                layout="fill"
                objectFit="cover"
              />
            </div>
            <div className={styles.banner_bottom_c}>
              <div className="row g-0">
                <div className="col-md-4">
                  <div className={styles.love_day}>
                    <Image src={love} alt="" layout="fill" objectFit="cover" />
                  </div>
                </div>
                <div className="col-md-8">
                  <div className={styles.discount_image}>
                    <Image src={offer} alt="" layout="fill" objectFit="cover" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
      {/* {!!categoryState.data?.firework_snippet && (
        <div
          className="my-3"
          dangerouslySetInnerHTML={{
            __html: categoryState.data.firework_snippet,
          }}
        ></div>
      )} */}
    </>
  );
};

export default CatgeoryBanner;
